export const modelData = {
    'bj40-pro': {
        slug: 'bj40-pro',
        name: 'BJ40 PRO',
        tagline: 'Break the Limits',

        hero: {
            title: 'BJ40 PRO',
            subtitle: 'BLACK EDITION',
            image: '/images/bj40-hero.jpg', // Placeholder path, user will need to valid images
        },

        sections: [
            {
                type: 'imageGrid',
                layout: 'masonry',
                images: [
                    '/images/bj40-1.jpg',
                    '/images/bj40-2.jpg',
                    '/images/bj40-3.jpg',
                    '/images/bj40-4.jpg',
                ],
            },

            {
                type: 'imageGrid',
                layout: 'twoByTwo',
                images: [
                    '/images/bj40-5.jpg',
                    '/images/bj40-6.jpg',
                    '/images/bj40-7.jpg',
                    '/images/bj40-8.jpg',
                ],
            },

            {
                type: 'features',
                title: 'Interior & Technology',
                items: [
                    {
                        title: 'Digital Cockpit',
                        image: '/images/bj40-interior-1.jpg',
                        description: 'Full digital instrument cluster with advanced connectivity.',
                    },
                    {
                        title: 'Premium Steering',
                        image: '/images/bj40-interior-2.jpg',
                        description: 'Leather wrapped multifunction steering wheel.',
                    },
                ],
            },

            {
                type: 'specTable',
                title: 'Technical Specifications',
                columns: ['BJ40 PRO', 'BJ40 PLUS'],
                rows: [
                    {
                        label: 'Engine',
                        values: ['2.0L Turbo', '2.0L Turbo'],
                    },
                    {
                        label: 'Power',
                        values: ['231 HP', '215 HP'],
                    },
                    {
                        label: 'Torque',
                        values: ['386 Nm', '380 Nm'],
                    },
                    {
                        label: 'Transmission',
                        values: ['8AT', '6AT'],
                    },
                    {
                        label: 'Dimensions (L x W x H)',
                        values: ['4645 x 1925 x 1871 mm', '4645 x 1925 x 1871 mm'],
                    },
                    {
                        label: 'Wheelbase',
                        values: ['2745 mm', '2745 mm'],
                    },
                ],
            },
        ],
    }
};
